// -- import * as _ from "lodash-es"
import * as api from "../../shared/api"
import * as biz_data_helper from "../../shared/biz_data_helper"

const content_type = "SalesTable"

const create = function () {
  return {
    content_type: "muji",
    age: 29
  }
}
const fields = {
  default: [{
    key: "AccountNum",
    label: "供应商编码",
    sortable: true,
  },
  {
    key: "ItemId",
    label: "物料编号",
    sortable: true
  },
  {
    key: "VariantName",
    label: "变型名称",
    sortable: true
  },
  {
    key: "Amount",
    label: "单价",
    sortable: true
  },
  {
    key: "Tax",
    label: "税率",
    sortable: true
  },
  {
    key: "Symbol",
    label: "单位",
    sortable: true,
  },
  {
    key: "CurrencyCode",
    label: "币别",
    sortable: true
  },
  {
    key: "FromDate",
    label: "开始日期",
    sortable: true,
    type: "date"
  },
  {
    key: "ToDate",
    label: "结束日期",
    sortable: true,
    type: "date"
  },
  {
    key: "QuantityAmountFrom",
    label: "数量开始",
    sortable: true
  },
  {
    key: "QuantityAmountTo",
    label: "数量结束",
    sortable: true
  },
  {
    key: "Remark",
    label: "价格备注",
    sortable: true
  },
  {
    key: "EXP",
    label: "EXP",
    sortable: true
  },
  {
    key: "M11",
    label: "M11纸张",
    sortable: true
  },
  {
    key: "M12",
    label: "M21油墨",
    sortable: true
  },
  {
    key: "M22",
    label: "M22光油",
    sortable: true
  },
  {
    key: "M23",
    label: "M23胶水",
    sortable: true
  },
  {
    key: "M24CTP",
    label: "M24CTP版",
    sortable: true
  },
  {
    key: "M25",
    label: "M25其他辅料",
    sortable: true
  },
  {
    key: "M26",
    label: "M26办公劳保",
    sortable: true
  },
  {
    key: "O11",
    label: "O11直接人工",
    sortable: true
  },
  {
    key: "O12",
    label: "O12间接人工",
    sortable: true
  },
  {
    key: "O23",
    label: "O23电",
    sortable: true
  },
  {
    key: "O24",
    label: "O24折旧",
    sortable: true
  },
  {
    key: "O25",
    label: "O25其他变动费用",
    sortable: true
  },
  {
    key: "O26",
    label: "O26其他固定费用",
    sortable: true
  },
  {
    key: "S11",
    label: "S11委外加工费",
    sortable: true
  },
  {
    key: "X",
    label: "X备件",
    sortable: true
  },
  {
    key: "Y",
    label: "Y半成品",
    sortable: true
  },
  {
    key: "Z",
    label: "Z成品",
    sortable: true
  },
  {
    key: "Cost_detail",
    label: "成本明细号",
    sortable: true
  },
  ],
  inventTable_fields: [{
    key: "ItemId",
    label: "物料编号",
  },
  {
    key: "NameAlias",
    label: "物料名称",
  },
  {
    key: "VariantName",
    label: "变型名称",
  },
  {
    key: "DW_InventUnitId",
    label: "单位",
  },
  {
    key: "TEC_CustAccount",
    label: "客户账户",
  },
  {
    key: "DW_CustName",
    label: "客户名称",
  },

  ],
  cust_fields: [

    {
      key: "AccountNum",
      label: "客户帐户"
    },
    {
      key: "SEI_Name",
      label: "客户名称",
    },
    {
      key: "Currency",
      label: "币种"
    },
    {
      key: "TaxGroup",
      label: "销售税组"
    },
    {
      key: "InclTax",
      label: "价格包括销售税"
    },


  ],
  salesTable_fields: [{
    key: "id",
    label: "编号",
  },
  {
    key: "SalesId",
    label: "销售订单编号"
  },
  {
    key: "CustAccount",
    label: "客户帐户"
  },
  {
    key: "SalesName",
    label: "客户名称",
  },
  {
    key: "InvoiceAccount",
    label: "发票帐户"
  },
  {
    key: "DeliveryDate",
    label: "装运日期",
  },
  {
    key: "CurrencyCode",
    label: "币种"
  },
  {
    key: "TaxGroup",
    label: "销售税组"
  },
  {
    key: "SalesPoolId",
    label: "池"
  },
  {
    key: "InclTax",
    label: "价格包括销售税"
  },
  {
    key: "TEC_Remark",
    label: "备注"
  },
  {
    key: "TEC_FinalCustAccount",
    label: "最终客户"
  },
  {
    key: "dataAreaId",
    label: "公司"
  },
  {
    key: "CompanyName",
    label: "公司名称",
    sortable: true,
    thStyle: { width: "8rem" },
    type: "short"
  },
  ],
}

///前端验证
const rules = {
  CustAccount: [{
    required: true,
    message: "请选择客户账户",
    trigger: "change"
  }],
  TEC_FinalCustAccount: [{
    required: true,
    message: "请选择最终客户",
    trigger: "change"
  }],
  InvoiceAccount: [{
    required: true,
    message: "请选择开票账户",
    trigger: "change"
  }],
  SalesPoolId: [{
    required: true,
    message: "请选择订单池",
    trigger: "change"
  }],
  dataAreaId: [{
    required: true,
    message: "请选择公司",
    trigger: "change"
  }],
  DeliveryDate: [{
    type: "date",
    required: true,
    message: "装运日期",
    trigger: "change"
  }]
  // TEC_Remark: [{ required: true, message: "请填写活动形式", trigger: "blur" }]
}

const descriptor = {
  name: {
    type: "string",
    required: true,
    validator: (rule, value) => value === "muji"
  },
  age: {
    type: "number",
    asyncValidator: (rule, value) => {
      return new Promise((resolve, reject) => {
        api
          .request({
            url: biz_data_helper.get_endpoint("test_fetch").url,
            parameters: {
              c: "a666"
            }
          })
          .then(res => {


            if (value == res.data[0].echo) {
              resolve(res)
            } else {
              reject("测试没通过")
            }
          })
          .catch(err => {
            reject(err)
          })
      })
    }
  }
}

const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
)
const methods = {
  //#region 订单主档相关
  ///get salesorder
  async getData(_params) {
    let _fields = _.map(fields.default, "key")

    let result = await biz_data
      .selectAction({
        params: _params,
        fields: _fields
      })
      .run()

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  //保存导入
  async SavePurchaseQuoteExport(json) {
    const code_biz_data = new biz_data_helper.base_entity_helper(
      "generate_VendPurchaseQuote", {}, {}
    )
    let result = await code_biz_data
      .execAction({
        params: {
          json: json
        },
        fields: []
      })
      .run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  ///save salesorder
  async savePurchPrice(data) {

    const biz_data = new biz_data_helper.base_entity_helper(
      "sPlant_Vend_Purchase_Price", create, descriptor
    )
    let _actions = []
    for (var i in data) {
      let sum = 0
      delete data[i]._current
      delete data[i]._id
      delete data[i]._selected
      if (data[i].QuantityAmountFrom == "") {
        delete data[i].QuantityAmountFrom
      }
      if (data[i].QuantityAmountTo == "") {
        delete data[i].QuantityAmountTo
      }
      if (data[i].ToDate == "") {
        delete data[i].ToDate
      }
      if (data[i].FromDate == "") {
        delete data[i].FromDate
      }
      if (data[i].EXP == "") {
        delete data[i].EXP
      } else {
        sum += data[i].EXP
      }
      if (data[i].M11 == "") {
        delete data[i].M11
      } else {
        sum += data[i].M11
      }
      if (data[i].M12 == "") {
        delete data[i].M12
      } else {
        sum += data[i].M12
      }
      if (data[i].M22 == "") {
        delete data[i].M22
      } else {
        sum += data[i].M22
      }
      if (data[i].M23 == "") {
        delete data[i].M23
      } else {
        sum += data[i].M23
      }
      if (data[i].M24CTP == "") {
        delete data[i].M24CTP
      } else {
        sum += data[i].M24CTP
      }
      if (data[i].M25 == "") {
        delete data[i].M25
      } else {
        sum += data[i].M25
      }
      if (data[i].M26 == "") {
        delete data[i].M26
      } else {
        sum += data[i].M26
      }
      if (data[i].O11 == "") {
        delete data[i].O11
      } else {
        sum += data[i].O11
      }
      if (data[i].O12 == "") {
        delete data[i].O12
      } else {
        sum += data[i].O12
      }
      if (data[i].O23 == "") {
        delete data[i].O23
      } else {
        sum += data[i].O23
      }
      if (data[i].O24 == "") {
        delete data[i].O24
      } else {
        sum += data[i].O24
      }
      if (data[i].O25 == "") {
        delete data[i].O25
      } else {
        sum += data[i].O25
      }
      if (data[i].O26 == "") {
        delete data[i].O26
      } else {
        sum += data[i].O26
      }
      if (data[i].S11 == "") {
        delete data[i].S11
      } else {
        sum += data[i].S11
      }
      if (data[i].X == "") {
        delete data[i].X
      } else {
        sum += data[i].X
      }
      if (data[i].Y == "") {
        delete data[i].Y
      } else {
        sum += data[i].Y
      }
      if (data[i].Z == "") {
        delete data[i].Z
      } else {
        sum += data[i].Z
      }
      data[i].AccountNum = data[i].AccountNum.toString()
      data[i].ItemId = data[i].ItemId.toString()
      //有成本在保存此项
      if (sum != 0) {

        data[i].Cost_Sum = parseFloat(parseFloat(sum).toFixed(6))
      }

      _actions.push(
        biz_data
          .insertAction({
            params: data[i],
            fields: ["id"]
          })
          .action({})
      )
    }

    let result = await api.query_batch({
      actions: _actions
    })

    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0 &&
      result.data.BatchResult.Actions[0].Result.Data.length > 0
    ) {
      return result.data.BatchResult.Actions[0].Result.Data
    } else {
      return null
    }
  },


  //#endregion

  //#region 订单明细相关
  // 获取供应商
  async getCustInfo(items) {
    const cust_biz_data = new biz_data_helper.base_entity_helper(
      "SEI_VendTable", create, descriptor
    )
    let custs = []
    _.each(items, t => {
      custs.push(t.AccountNum.toString())
    })
    _
    let result = await cust_biz_data.selectAction({
      params: {
        AccountNum: {
          "in": custs
        },
      },
      fields: _.map(fields.cust_fields, "key")
    }).run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  //getgetNameAlias 获取物料名称
  async getNameAlias(items) {
    const item_biz_data = new biz_data_helper.base_entity_helper(
      "SEI_InventTable", create, descriptor
    )
    let ItemIds = []
    _.each(items, t => {
      ItemIds.push(t.ItemId.toString())
    })
    let result = await item_biz_data
      .selectAction({
        params: {
          ItemId: {
            "in": ItemIds
          },
        },
        fields: _.map(fields.inventTable_fields, "key")
      })
      .run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },

  ///get so items
  async getItemData(_params) {
    let item_biz_data = new biz_data_helper.base_entity_helper(
      "SalesLine",
      create,
      descriptor
    )
    let _fields = _.map(fields.detail_fields, "key")
    _fields.push("id")
    _fields.push("SalesTable_id")
    // _fields.push("DiscPrice");
    _.remove(_fields, n => {
      return n == "price_state"
    })
    let result = await item_biz_data
      .selectAction({
        params: _params,
        fields: _fields
      })
      .run()

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },


  ///del so items
  async deleteItemData(items) {
    let _actions = []

    let item_biz_data = new biz_data_helper.base_entity_helper(
      "SalesLine",
      create,
      descriptor
    )

    _.each(items, t => {
      _actions.push(
        item_biz_data
          .deleteAction({
            params: {
              id: t.id
            }
          })
          .action({})
      )
    })
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0 &&
      result.data.BatchResult.Actions[0].Result.Data.length > 0
    ) {
      return true
    } else {
      return false
    }
  }
  //#endregion
}
export {
  biz_data, fields,
  methods,
  rules
}

